

exports.__esModule = true;
exports.$FullpageOnetouchUpsellRoute = undefined;

var _squid = require('squid');

require('./directive');

var $FullpageOnetouchUpsellRoute = exports.$FullpageOnetouchUpsellRoute = _squid.$ComponentRoute.extend('FullpageOnetouchUpsellRoute', {
    name: 'FullpageOnetouchUpsell',
    directive: 'xo-fullpage-onetouch-upsell',
    trackingData: {
        fptiState: 'fullpage-onetouch-upsell',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-onetouch-upsell',
                'pagename2': '%::fullpage-onetouch-upsell:member:hermes:',
                'version': 'member:%:'
            }
        }
    },

    children: []
});

angular.value("$FullpageOnetouchUpsellRoute", $FullpageOnetouchUpsellRoute);
_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-login-components/src/fullpage-onetouch-upsell/route.js
// module id = ../node_modules/xo-login-components/src/fullpage-onetouch-upsell/route.js
// module chunks = 0